<template>
  <div>
    <div>
      <H5>Search By:</H5>
      <div>
        <p-button
          type="info"
          size="sm"
          round
          v-for="button in  searchTypeButtons"
          :key="button.type"
          @click="toggleSearch(button)"
          :class="{ searchSelected: button.selected }"
        >{{button.text}}</p-button>
      </div>

      <form ref="searchForm" @submit.prevent="searchSubmit">
        <input
          class="search-field"
          placeholder="Search by Keyword"
          v-if="searchType =='keyword'"
          v-model="keywordSearchField"
          v-on:keyup.enter="searchSubmit"
        />
        <div v-if="searchType =='hashtag' ">
          <vue-autosuggest
            v-model="hashtagSearchField"
            :suggestions="hashtagList"
            @input="loadHashtags"
            @selected="hashtagSearch"
            :get-suggestion-value="setHashtagValue"
            :input-props="hashtagProps"
          ></vue-autosuggest>
        </div>
        <div v-if="searchType =='location' ">
          <vue-autosuggest
            :v-model="setLocationFieldDisplay"
            :suggestions="locationList"
            @input="loadLocations"
            @selected="locationSearch"
            :input-props="locationProps"
          ></vue-autosuggest>
        </div>

        <!--<div>
            <v-btn @click.prevent="searchSubmit">SEARCH</v-btn>
        </div>-->
      </form>
    </div>
    <div v-if="searchActive == true">
      <div class="lds-dual-ring"></div>
    </div>
    <div v-else>
      <div v-if="searchResults != null">
        <div v-if="searchResults === 0 && progressiveLoad === true">
          <h1>Loading Profiles...</h1>
        </div>
        <h3 v-if="searchType == 'location'">
          <span v-if="currentSearchLocation !== null"></span>
        </h3>
        <div class="card" style="margin-top:25px;">
          <div class="card-header">
            <h5 class="card-title">{{searchResults.length}} Influencer results:</h5>
          </div>

          <div class="card-body row">
            <div class="col-sm-12">
              <el-table
                :data="searchResults"
                header-row-class-name="text-primary"
                class="table-striped"
              >
                <el-table-column label="Influencer">
                  <template slot-scope="props">
                    <div class="table-cell">
                      <a :href="'https://instagram.com/'+props.row.profileName" target="_blank">
                        <img
                          :src="props.row.profilePic"
                          class="influencer-img"
                          @error="profilePicLoadCache(props.row.profileName)"
                        />
                      </a>
                      <br />
                      <a
                        :href="'https://instagram.com/'+props.row.profileName"
                        target="_blank"
                      >@{{props.row.profileName}}</a>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Bio">
                  <template slot-scope="props">
                    <div class="table-cell">{{props.row.bio}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Followers">
                  <template slot-scope="props">
                    <div class="table-cell">{{props.row.followerCount}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="ER">
                  <template slot-scope="props">
                    <div
                      class="table-cell"
                      v-if="typeof props.row.engagementRate !== 'undefined'"
                    >{{ (props.row.engagementRate *100).toFixed(2) }}%</div>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="props">
                    <div class="table-cell">
                      <p-button
                        type="info"
                        link
                        @click="$router.push('/instagram/details/?instagram='+props.row.profileName)"
                      >
                        view details
                        <i class="fa fa-angle-right"></i>
                      </p-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import {
  influencerCandidateSearchRelatedApi,
  influencerCandidateSearchLocationApi,
  influencerCandidateSearchLocationLoadApi,
  influencerCandidateSearchLRelatedLoadApi,
  influencerCandidateSearchHashtagApi,
  influencerCandidateSearchLHashtagLoadApi,
  influencerCandidateSearchKeywordApi,
  influencerCandidateSearchLKeywordLoadApi,
  instagramProfileCacheApi,
} from "@/config/appSettings";
import PPagination from "src/components/UIComponents/Pagination.vue";
import { VueAutosuggest } from "vue-autosuggest";
export default {
  data: () => ({
    loadingOverlay: false,
    searchActive: false,
    loadingOverlayText: null,
    campaigns: null,
    searchResults: null,
    candidateList: null,
    searchType: null,
    searchRelated: null,
    searchHashtag: null,
    searchKeyword: null,
    searchQuery: null,
    searchField: null,
    locationSearchField: null,
    relatedSearchField: null,
    keywordSearchField: null,
    locationSearchName: null,
    hashtagSearchField: null,
    locationList: [],
    locationData: null,
    hashtagList: [],

    progressiveLoad: false,
    currentSearchLocation: null,
    reloadData: null,

    locationProps: null,
    hashtagProps: null,
    inputLocationProps: null,
    searchTypeButtons: [
      { type: "hashtag", text: "hashtag", selected: false },
      { type: "keyword", text: "keyword", selected: false },
      { type: "location", text: "location", selected: false },

      /*{ type: "related_profiles", text: "related profiles", selected: false }*/
    ],
    searchHeaders: [
      {
        text: "",
        align: "left",
        sortable: false,
        value: "",
      },
      { text: "Instagram", value: "profileName" },
      { text: "Bio", value: "bio", sortable: false },
      { text: "Followers", value: "followerCount" },
      { text: "Engagement Rate", value: "engagementRate" },
      { text: "", value: "", sortable: false },
    ],
  }),
  name: "InfluencerCandidateSearch",
  components: {
    VueAutosuggest,
  },
  methods: {
    async toggleSearch(search) {
      //console.log(search);
      try {
        //this.progressiveLoad = false;
        //this.reloadData = {};
        //console.log("BUTTON CLICKED:", search.type)
        //console.log("SEARCH TYPE:", this.searchType)
        //console.log("QUERY TYPE:", this.$route.query.type)
        this.searchType = search.type;
        this.searchTypeButtons = this.searchTypeButtons.map((x) => {
          if (search.type == x.type) {
            return { type: x.type, text: x.text, selected: true };
          }
          return { type: x.type, text: x.text, selected: false };
        });
        //console.log("SEARCH TYPE BUTTONS:", this.searchTypeButtons);

        if (this.searchType !== this.$route.query.type) {
          this.$router.push({
            query: { type: this.searchType },
          });
          this.searchType = this.$route.query.type;
          //console.log("CHANGING SEARCH TYPE:", this.searchType);
        }
        this.searchResults = null;

        //this.$refs.searchForm.reset();
        /*if (search.type === "location") {
        this.reloadData = { location: "" };
      }
      if (search.type === "hashtag") {
        this.reloadData = { searchHashtag: "" };
      }*/
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async searchSubmit() {
      try {
        this.searchResults = [];
        if (this.searchType === null) {
          this.searchType = "related_profiles";
          this.searchQuery = this.searchField;
        }

        if (this.searchType === "location") {
          this.searchQuery = this.locationSearchField;
        }
        if (this.searchType === "related_profiles") {
          this.searchQuery = this.relatedSearchField;
        }
        if (this.searchType === "hashtag") {
          this.searchQuery = this.hashtagSearchField;
          this.searchHashtag = this.hashtagSearchField;
        }
        if (this.searchType === "keyword") {
          this.searchQuery = this.keywordSearchField;
          this.searchKeyword = this.keywordSearchField;
        }
        if (this.searchQuery !== this.$route.query.q) {
          this.$router.push({
            query: { q: this.searchQuery, type: this.searchType },
          });
        }
        if (
          this.$route.query.type !== null &&
          this.$route.query.type.trim() !== "" &&
          typeof this.$route.query.type !== "undefined"
        ) {
          this.searchType = this.$route.query.type;
        }

        this.searchRequest();
      } catch (err) {
        console.log(err);
      }
    },
    async hashtagSearch(input) {
      //console.log("ITEM:", input);
      if (typeof input !== "undefined" && input !== null) {
        this.hashtagSearchField = input.item;
        this.searchSubmit();
        return;
      }
      if (this.hashtagSearchField !== null) {
        this.searchSubmit();
        return;
      }
    },
    async locationSearch(input) {
      //console.log("ITEM:", input);
      let locationId = this.locationData.filter((x) => {
        return x.name == input.item;
      });
      //console.log("Location Id:", locationId[0]);
      if (typeof input !== "undefined" && input !== null) {
        this.locationSearchField = locationId[0].placeId;
        this.searchSubmit();
        return;
      }
      if (this.locationSearchField !== null) {
        this.searchSubmit();
        return;
      }
    },
    async searchRequest() {
      try {
        //console.log("SEARCH TERM:", this.$route.query.q);
        if (typeof this.$route.query.q === "undefined") {
          return;
        }
        if (this.$route.query.q === null) {
          return;
        }

        if (this.$route.query.q.trim() === "") {
          return;
        }
        if (this.progressiveLoad === false) {
          this.loadingOverlay = true;
        }

        this.loadingOverlayText = "Loading Results...";
        this.searchType = this.$route.query.type;

        // RELATED PROFILE SEARCH
        if (this.searchType === "related_profiles") {
          let influencerCandidateSearchUrl = `${influencerCandidateSearchRelatedApi}/?usertoken=${this.auth}&instagram=${this.$route.query.q}`;
          let influencerCandidateList = await axios.get(
            influencerCandidateSearchUrl
          );
          this.searchRelated = this.$route.query.q;
          //console.log("CAMPAIGN DATA: ", influencerCandidateList.data);
          if (influencerCandidateList.data.success === true) {
            this.searchResults = influencerCandidateList.data.result;
            let savedSearch = {};
            savedSearch.profileList =
              influencerCandidateList.data.searchProfiles;
            savedSearch.relatedSearchProfile =
              influencerCandidateList.data.relatedSearchProfile;
            this.reloadData = savedSearch;
            //console.log("HERE IS THE SAVED SEARCH FIRST LOAD: ", savedSearch);
          }

          if (influencerCandidateList.data.status === "processing") {
            this.progressiveLoad = true;
            setTimeout(() => {
              this.loadRelatedResults();
            }, 2000);
          } else {
            this.progressiveLoad = false;
          }
          return;
        }

        // LOCATION PROFILE SEARCH
        if (this.searchType === "location") {
          let locationSearchQuery = this.locationList.filter((x) => {
            return x.placeId == this.$route.query.q;
          });
          //console.log("HERE IS THE LOCATION LIST:", this.locationList);
          //console.log("LOCATION SEARCH QUERY:", locationSearchQuery);
          let influencerCandidateSearchUrl = `${influencerCandidateSearchLocationApi}/?usertoken=${this.auth}&location=${this.$route.query.q}`;
          let influencerCandidateList = await axios.get(
            influencerCandidateSearchUrl
          );
          //console.log("LOCATION DATA: ", influencerCandidateList.data);
          if (influencerCandidateList.data.success === true) {
            this.searchResults = influencerCandidateList.data.result;
            let savedSearch = {};
            savedSearch.profileList =
              influencerCandidateList.data.searchProfiles;
            savedSearch.location = influencerCandidateList.data.location;
            this.reloadData = savedSearch;
            //console.log("HERE IS THE SAVED SEARCH FIRST LOAD: ", savedSearch);
          }

          if (influencerCandidateList.data.status === "processing") {
            this.progressiveLoad = true;
            setTimeout(() => {
              this.loadLocationResults();
            }, 2000);
          } else {
            this.progressiveLoad = false;
          }
          return;
        }

        //HASHTAG PROFILE SEARCH
        if (this.searchType === "hashtag") {
          this.searchActive = true;
          let hashtagSearchQuery = this.hashtagList.filter((x) => {
            return x.name === this.$route.query.q;
          });

          //console.log("HERE IS THE HASHTAG LIST:", this.hashtagList);
          //console.log("HASHTAG SEARCH QUERY:", hashtagSearchQuery);
          let influencerCandidateSearchUrl = `${influencerCandidateSearchHashtagApi}/?usertoken=${this.auth}&hashtag=${this.$route.query.q}`;
          console.log(
            "HASHTAG SEARCH QUERY URL:",
            influencerCandidateSearchUrl
          );
          let influencerCandidateList = await axios.get(
            influencerCandidateSearchUrl
          );
          console.log("HASHTAG DATA: ", influencerCandidateList.data);
          if (influencerCandidateList.data.success == true) {
            this.searchActive = false;
            this.searchResults = influencerCandidateList.data.result;
            let savedSearch = {};
            savedSearch.profileList =
              influencerCandidateList.data.searchProfiles;
            savedSearch.searchHashtag =
              influencerCandidateList.data.searchHashtag;
            this.reloadData = savedSearch;
            this.searchHashtag = influencerCandidateList.data.searchHashtag;
            //console.log("HERE IS THE SAVED SEARCH FIRST LOAD: ", savedSearch);
          }

          if (influencerCandidateList.data.status === "processing") {
            this.progressiveLoad = true;
            setTimeout(() => {
              this.loadHashtagResults();
            }, 2000);
          } else {
            this.progressiveLoad = false;
          }
          return;
        }

        //KEYWORD PROFILE SEARCH
        if (this.searchType === "keyword") {
          this.searchActive = true;
          let influencerCandidateSearchUrl = `${influencerCandidateSearchKeywordApi}/?usertoken=${this.auth}&keyword=${this.$route.query.q}`;
          console.log("KEYWORD SEARCH URL: ", influencerCandidateSearchUrl);
          let influencerCandidateList = await axios.get(
            influencerCandidateSearchUrl
          );
          console.log("KEYWORD DATA: ", influencerCandidateList.data);
          if (influencerCandidateList.data.success == true) {
            this.searchActive = false;
            this.searchResults = influencerCandidateList.data.result;
            let savedSearch = {};
            savedSearch.profileList =
              influencerCandidateList.data.searchProfiles;
            savedSearch.searchKeyword =
              influencerCandidateList.data.searchKeyword;
            this.reloadData = savedSearch;
            this.searchKeyword = influencerCandidateList.data.searchKeyword;
            //console.log("HERE IS THE SAVED SEARCH FIRST LOAD: ", savedSearch);
          }

          if (influencerCandidateList.data.status === "processing") {
            this.progressiveLoad = true;
            setTimeout(() => {
              this.loadKeywordResults();
            }, 2000);
          } else {
            this.progressiveLoad = false;
          }
          return;
        }

        //console.log("NO SEARCH QUERY:", this.searchQuery);
      } catch (err) {
        //console.log(err);
      }
    },
    async loadLocationResults() {
      try {
        if (this.progressiveLoad === false) {
          this.loadingOverlay = true;
        }

        this.loadingOverlayText = "Loading Results...";
        this.searchType = this.$route.query.type;

        //console.log("HERE IS THE LOCATION LIST:", this.locationList);
        //console.log("HERE IS THE SAVED SEARCH RELOADED: ", this.reloadData);
        let reloadData = {};
        reloadData.usertoken = this.auth;
        reloadData.location = this.reloadData.location;
        reloadData.profileList = this.reloadData.profileList;
        this.locationSearchName = this.reloadData.location.locationName;

        let influencerCandidateList = await axios.post(
          influencerCandidateSearchLocationLoadApi,
          reloadData
        );
        //console.log("LOCATION DATA: ", influencerCandidateList.data);
        if (influencerCandidateList.data.success === true) {
          this.searchResults = influencerCandidateList.data.result;
        }
        this.loadingOverlay = false;
        if (influencerCandidateList.data.status === "processing") {
          this.progressiveLoad = true;
          setTimeout(() => {
            this.loadLocationResults();
          }, 6000);
        } else {
          this.progressiveLoad = false;
        }

        this.loadingOverlay = false;

        //console.log("NO SEARCH QUERY:", this.searchQuery);
      } catch (err) {
        //console.log(err);
      }
    },
    async loadRelatedResults() {
      try {
        if (this.progressiveLoad === false) {
          this.loadingOverlay = true;
        }

        this.loadingOverlayText = "Loading Results...";
        this.searchType = this.$route.query.type;

        //console.log("HERE IS THE SAVED SEARCH RELOADED: ", this.reloadData);
        let reloadData = {};
        reloadData.usertoken = this.auth;
        reloadData.relatedSearchProfile = this.reloadData.relatedSearchProfile;
        reloadData.profileList = this.reloadData.profileList;

        this.searchRelated = this.reloadData.relatedSearchProfile;

        let influencerCandidateList = await axios.post(
          influencerCandidateSearchLRelatedLoadApi,
          reloadData
        );
        //console.log("RELATED PROFILE DATA: ", influencerCandidateList.data);
        if (influencerCandidateList.data.success === true) {
          this.searchResults = influencerCandidateList.data.result;
        }
        this.loadingOverlay = false;
        if (influencerCandidateList.data.status === "processing") {
          this.progressiveLoad = true;
          setTimeout(() => {
            this.loadRelatedResults();
          }, 6000);
        } else {
          this.progressiveLoad = false;
        }

        this.loadingOverlay = false;

        //console.log("NO SEARCH QUERY:", this.searchQuery);
      } catch (err) {
        //console.log(err);
      }
    },
    async loadHashtagResults() {
      try {
        if (this.progressiveLoad === false) {
          this.loadingOverlay = true;
        }

        this.loadingOverlayText = "Loading Results...";
        this.searchType = this.$route.query.type;

        //console.log("HERE IS THE SAVED SEARCH RELOADED: ", this.reloadData);
        let reloadData = {};
        reloadData.usertoken = this.auth;
        reloadData.searchHashtag = this.reloadData.searchHashtag;
        reloadData.profileList = this.reloadData.profileList;

        let influencerCandidateList = await axios.post(
          influencerCandidateSearchLHashtagLoadApi,
          reloadData
        );
        //console.log("RELATED PROFILE DATA: ", influencerCandidateList.data);
        if (influencerCandidateList.data.success === true) {
          this.searchResults = influencerCandidateList.data.result;
          this.searchHashtag = influencerCandidateList.data.searchHashtag;
        }
        //this.loadingOverlay = false;
        if (influencerCandidateList.data.status === "processing") {
          this.progressiveLoad = true;
          setTimeout(() => {
            this.loadHashtagResults();
          }, 6000);
        } else {
          this.progressiveLoad = false;
        }

        this.loadingOverlay = false;

        //console.log("NO SEARCH QUERY:", this.searchQuery);
      } catch (err) {
        //console.log(err);
      }
    },
    async loadKeywordResults() {
      try {
        if (this.progressiveLoad === false) {
          this.loadingOverlay = true;
        }

        this.loadingOverlayText = "Loading Results...";
        this.searchType = this.$route.query.type;

        //console.log("HERE IS THE SAVED SEARCH RELOADED: ", this.reloadData);
        let reloadData = {};
        reloadData.usertoken = this.auth;
        reloadData.searchKeyword = this.reloadData.searchKeyword;
        reloadData.profileList = this.reloadData.profileList;

        let influencerCandidateList = await axios.post(
          influencerCandidateSearchLKeywordLoadApi,
          reloadData
        );
        //console.log("RELATED PROFILE DATA: ", influencerCandidateList.data);
        if (influencerCandidateList.data.success === true) {
          this.searchResults = influencerCandidateList.data.result;
          this.searchKeyword = influencerCandidateList.data.searchKeyword;
        }
        this.loadingOverlay = false;
        if (influencerCandidateList.data.status === "processing") {
          this.progressiveLoad = true;
          setTimeout(() => {
            this.loadKeywordResults();
          }, 6000);
        } else {
          this.progressiveLoad = false;
        }

        this.loadingOverlay = false;

        //console.log("NO SEARCH QUERY:", this.searchQuery);
      } catch (err) {
        //console.log(err);
      }
    },
    async profilePicLoadCache(instagramProfile) {
      try {
        let profileCacheUrl = `${instagramProfileCacheApi}/?usertoken=${this.auth}&instagram=${instagramProfile}`;
        console.log("PROFILE CACHE:", profileCacheUrl);
        let profileCacheResponse = await axios.get(profileCacheUrl);
        console.log(`LOADING ${instagramProfile}`, profileCacheResponse.data);
      } catch (err) {
        console.log("ERR", err);
      }
    },
    async setHashtagValue(val) {
      return val.name;
    },
    async setLocationValue(val) {
      //console.log("VALUE:", val);
      return val.name;
    },
    async setHashtagDisplay(val) {
      return val.item.nameString;
    },
    async setLocationFieldDisplay() {
      if (this.locationSearchField !== null) {
        let locationCheck = this.locationData.filter((x) => {
          return x.placeId == this.locationSearchField;
        });
        if (locationCheck.length > 0) {
          return x.name;
        }
      }
    },
    async loadHashtags(val) {
      try {
        //console.log("QUERY:", val);
        if (typeof val !== "undefined") {
          if (val.length > 2) {
            let locationResponse = await axios.get(
              `https://www.instagram.com/web/search/topsearch/?context=hashtag&query=${val}`
            );
            //console.log("CHECKING LOCATIONS:", locationResponse.data);
            this.hashtagList = [
              {
                data: locationResponse.data.hashtags.map((x) => {
                  /*return {
                    name: x.hashtag.name,
                    nameString: `${x.hashtag.name}`
                  };*/
                  return x.hashtag.name;
                }),
              },
            ];
            //console.log("HASHTAG LIST:", this.hashtagList);

            //return this.hashtagList;
          }
        }
        return this.hashtagList;
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadLocations(val) {
      try {
        //console.log("QUERY:", val);
        if (typeof val !== "undefined") {
          //console.log("QUERY:", val);
          if (val.length > 2) {
            let locationResponse = await axios.get(
              `https://www.instagram.com/web/search/topsearch/?context=place&query=${val}`
            );
            //console.log("CHECKING LOCATIONS:", locationResponse.data);
            this.locationData = locationResponse.data.places.map((x) => {
              let placeName = x.place.location.name;
              if (x.place.location.city.trim() !== "") {
                placeName = `${placeName} - ${x.place.location.city}`;
              }
              //return placeName
              return {
                name: placeName,
                placeId: x.place.location.pk,
              };
            });
            this.locationList = [
              {
                data: this.locationData.map((x) => {
                  return x.name;
                }),
              },
            ];
            //console.log("LOCATION LIST:", this.locationList);

            return;
          }
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
  },
  watch: {
    async searchType(val) {
      //console.log("UPDATING...", val);

      try {
        if (val == "location") {
          this.inputProps = {
            id: "autosuggest__input",
            onInputChange: this.loadLocations,
            placeholder: "Search by location",
          };
        }
        if (val == "hashtag") {
          this.inputProps = {
            id: "autosuggest__input",
            onInputChange: this.loadHashtags,
            placeholder: "Search by Hashtag",
          };
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR");
      }
    },
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.searchRequest();
    this.searchType = this.$route.query.type;
    this.locationProps = {
      id: "autosuggest__input",
      onInputChange: this.loadLocations,
      placeholder: "Search by location",
    };
    this.hashtagProps = {
      id: "autosuggest__input",
      onInputChange: this.loadHashtags,
      placeholder: "Search by Hashtag",
    };

    console.log("IN SEARCH INSTANCE!");
    try {
      if (
        typeof this.$route.query.type == "undefined" ||
        this.$route.query.type == null
      ) {
        this.searchType = "keyword";
      } else {
        this.searchType = this.$route.query.type;
      }
    } catch (err) {
      this.searchType = "keyword";
    }
    try {
      //console.log("SEARCH TYPE:", this.searchType);
      //console.log("SEARCH BUTTONS:", this.searchTypeButtons);

      let searchButton = this.searchTypeButtons.filter((x) => {
        return x.type === this.searchType;
      });

      console.log("SEARCH BUTTON:", searchButton[0]);

      this.toggleSearch(searchButton[0]);
    } catch (err) {
      console.log("THERE WAS AN ERROR:", err);
    }

    /*if (
      typeof this.$route.query.q !== "undefined" &&
      this.$route.query.q !== null
    ) {
      this.searchQuery == this.$route.query.q;
      this.searchField == this.$route.query.q;
    }
    this.searchType = this.$route.query.type;
    
    try {
      if (
        typeof this.$route.query.type == "undefined" ||
        this.$route.query.type == null
      ) {
        this.searchType = "keyword";
      } else {
        this.searchType = this.$route.query.type;
      }
    } catch (err) {
      this.searchType = "keyword";
    }
    try {
      console.log("SEARCH TYPE:", this.searchType);
      console.log("SEARCH BUTTONS:", this.searchTypeButtons);

      let searchButton = this.searchTypeButtons.filter(x => {
        return x.type === this.searchType;
      });

      console.log("SEARCH BUTTON:", searchButton[0]);

      this.toggleSearch(searchButton[0]);
    } catch (err) {
      console.log("THERE WAS AN ERROR:", err);
    }*/
  },
};
</script>
<style scoped>
.influencer-img {
  width: 75px;
  margin: 10px;
  border-radius: 5px;
}
.searchSelected {
  color: white;
  background-color: orange !important;
}
.table-cell {
  width: 100%;
  padding: 10px;
}
</style>